import React, { FC } from 'react';
import { BodyText } from '@minecraft.atoms';
import { Trans, useTranslation } from '@blocs.i18n';
import { HeadshotsInfoModal } from './HeadshotsInfoModal';
import { UseHeadshotFreeModalValues } from './useHeadshotFreeModal';

export type HeadshotsFreeModalProps = {
  onUpgrade: UseHeadshotFreeModalValues['handleFreeUpgrade'];
  onClose: () => void;
};

/**
 * Free and Essential upsell shown when Headshots is opened. Copy only —
 * eligibility and the upgrade flow live in `useHeadshotFreeModal`.
 */
export const HeadshotsFreeModal: FC<HeadshotsFreeModalProps> = ({ onUpgrade, onClose }) => {
  const { t } = useTranslation();

  return (
    <HeadshotsInfoModal
      title={t('talent:headshots.freeModal.title')}
      body={t('talent:headshots.freeModal.body')}
      benefits={[
        {
          id: 'annual',
          label: (
            <Trans
              i18nKey="talent:headshots.freeModal.annualBenefit"
              components={{ bold: <BodyText as="span" fontWeight="bold" /> }}
            />
          ),
        },
        {
          id: 'monthly',
          label: (
            <Trans
              i18nKey="talent:headshots.freeModal.monthlyBenefit"
              components={{ bold: <BodyText as="span" fontWeight="bold" /> }}
            />
          ),
        },
      ]}
      primaryActionLabel={t('talent:headshots.freeModal.upgradeNow')}
      onPrimaryAction={onUpgrade}
      secondaryActionLabel={t('talent:headshots.freeModal.maybeLater')}
      onSecondaryAction={onClose}
      closeLabel={t('common:button.close')}
      onClose={onClose}
    />
  );
};

export default HeadshotsFreeModal;
